<template>
  <div class="my-integral-record-details">
    <div class="details-content">
      <div class="info-box">
        <div class="info-title">会员信息</div>
        <div class="info-row">
          <div class="info-name">会员名称</div>
          <div class="info-value">{{userInfo.userName}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">手机号</div>
          <div class="info-value">{{userInfo.phoneNo}}</div>
        </div>
      </div>
      <div class="info-box" v-if="pageType == 'integral-record'">
        <template v-if="details.transactionMethod == 1">
          <div class="info-title">签到信息</div>
          <div class="info-row">
            <div class="info-name">签到天数</div>
            <div class="info-value">{{details.transactionMethodDesc}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">签到时间</div>
            <div class="info-value">{{details.createTime}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">积分值</div>
            <div class="info-value">{{details.transactionPoints}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">积分活动</div>
            <div class="info-value">{{details.cmpnName}}</div>
          </div>
        </template>
        
        <template v-else-if="details.transactionMethod == 2">
          <div class="info-row">
            <div class="info-name">订单号</div>
            <div class="info-value">{{details.createTime}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">充电金额</div>
            <div class="info-value">{{details.totalAmount}}元</div>
          </div>
          <div class="info-row">
            <div class="info-name">充电量</div>
            <div class="info-value">{{details.chargeElect}}度</div>
          </div>
          <div class="info-row">
            <div class="info-name">支付时间</div>
            <div class="info-value">{{details.payTime}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">积分值</div>
            <div class="info-value">{{details.transactionPoints}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">积分活动</div>
            <div class="info-value">{{details.cmpnName}}</div>
          </div>
        </template>
        <template v-else>
          <div class="info-row">
            <div class="info-name">类型</div>
            <div class="info-value">{{details.transactionMethodDesc}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">时间</div>
            <div class="info-value">{{details.createTime}}</div>
          </div>
          <div class="info-row">
            <div class="info-name">积分值</div>
            <div class="info-value">{{details.transactionPoints}}</div>
          </div>
        </template>
      </div>
      <div class="info-box" v-else>
        <div class="info-title">订单信息</div>
        <div class="info-row">
          <div class="info-name">兑换订单号</div>
          <div class="info-value">{{details.orderNo}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">兑换物品</div>
          <div class="info-value">{{details.vipName}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">兑换积分</div>
          <div class="info-value">{{details.transactionPoints}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">剩余积分</div>
          <div class="info-value">{{details.afterPoints}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">兑换方式</div>
          <div class="info-value">{{details.transactionMethodDesc}}</div>
        </div>
        <div class="info-row">
          <div class="info-name">兑换时间</div>
          <div class="info-value">{{details.createTime}}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {  } from "vant";
import {
  getUserBaseInfo
} from "../../common/api";

export default {
  name: "my-integral-record-details",
  components: {
  },
  data() {
    return {
      pageType: 'integral-record',
      details: {},
      userInfo: {}
    }
  },
  mounted() {
    let query = this.$route.query;
    if(query.pageType){
      this.pageType = query.pageType;
    }
    this.details = this.$common.get('integral-record-details') || {};
    console.log(this.details)
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      getUserBaseInfo(null, true).then((response) => {
        if (
          response.status == this.$config.ajaxStatus &&
          response.data.length > 0
        ) {
          this.userInfo = response.data[0];
        }
      });
    },

  }
}
</script>
<style lang="less">
.my-integral-record-details{
  min-height: 100%;
  background-color: #F5F4F9;
  padding: 0.2rem;
  box-sizing: border-box;
  .details-content{
    background-color: #fff;
    border-radius: 0.12rem;
    padding: 0 0.2rem;
    .info-box:first-child{
      border-bottom: 1px solid #D8D8D8;
    }
    .info-box{
      padding: 0.2rem 0;
      .info-title{
        color: #000000;
        font-size: 0.28rem;
        line-height: 0.4rem;
      }
      .info-row{
        margin-top: 0.2rem;
        display: flex;
        font-size: 0.24rem;
        line-height: 0.33rem;
        .info-name{
          width: 1.56rem;
          color: #999999;
        }
        .info-value{
          flex: 1;
          color: #000;
        }
      }
    }
  }
}
</style>